import { z } from 'zod';

export const CloseDealDTOSchema = z.object({
  parentType: z.string(),
  reasonStatus: z.string(),
  stageId: z.string().uuid(),
  reasonId: z.string().uuid(),
  parentId: z.string().uuid(),
});

export const ReopenDealDTOSchema = z.object({
  parentType: z.string(),
  parentId: z.string().uuid(),
});
